<template>
  <div class="add-user">
    <el-form
      label-position="top"
      :model="user"
      :rules="rules"
      ref="addUserForm"
      :disabled="loading">
      <el-form-item
        :label="$t('name')" prop="name">
        <el-input v-model="user.name" />
      </el-form-item>
      <el-form-item
        :label="$t('email')" prop="email">
        <el-input v-model="user.email" class="ltr tahoma text-right"/>
      </el-form-item>
      <el-form-item
        :label="$t('mobile')" prop="mobile">
        <div class="el-input">
          <masked-input class="el-input__inner ltr tahoma text-right"
            v-model="user.mobile"
            :mask="setPhoneNumberMask()" />
        </div>
      </el-form-item>
      <el-form-item
        :label="$t('password')" prop="password">
        <el-input
        v-model="user.password"
        :type="passwordVisible ? 'text' : 'password'"
        :placeholder="$t('password')"
        class="tahoma">
          <i slot="prefix"
          :class="`searchable
          el-input__icon fas fa-eye${passwordVisible ? '-slash' : ''}`"
          @click="passwordVisible = !passwordVisible"></i>
        </el-input>
      </el-form-item>
      <el-form-item
        :label="$t('team_name')">
        <el-input v-model="user.team.name" />
      </el-form-item>
      <el-form-item
        :label="$t('plan')">
        <el-select
          v-model="plan.id"
          placeholder="Select">
          <el-option
            v-for="plan in plans"
            :key="`${plan.id.numberStr}`"
            :label="plan.name"
            :value="plan.id.numberStr">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        :label="$t('plan_expiration')">
        <el-select
          v-model="plan.expiration"
          placeholder="Select">
          <el-option
            v-for="interval in intervals"
            :key="interval.name"
            :label="$t(interval.name)"
            :value="interval.value">
          </el-option>
        </el-select>
      </el-form-item>
      <div class="line"></div>
      <el-form-item class="no-margin">
        <el-button
         @click="validateAndSubmitForm('addUserForm', createUserWithTeam)"
         :loading="loading" type="primary">
          {{ $t('submit') }}
        </el-button>
        <el-button
         @click="$emit('close-clicked')"
         :loading="loading">
          {{ $t('close') }}
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { converntDigitsToLatin } from '@/utils/digits'
import MaskedInput from 'vue-masked-input'
export default {
  data () {
    const secondsInDays = () => 60 * 60 * 24
    const secondsInWeek = () => secondsInDays() * 7
    const secondsInMonth = () => secondsInDays() * 30
    const secondsInThreeMonth = () => secondsInMonth() * 3
    return {
      user: {
        name: '',
        email: '',
        mobile: '',
        password: '',
        team: {
          name: ''
        }
      },
      plan: {
        id: '',
        expiration: secondsInWeek()
      },
      rules: {
        name: {
          required: true,
          message: this.$i18n.t('field_required')
        },
        email: [{
          required: true,
          message: this.$i18n.t('field_required')
        }, {
          type: 'email',
          message: this.$i18n.t('email_validation')
        }],
        mobile: [{
          required: true,
          message: this.$i18n.t('field_required')
        }],
        password: [{
          required: true,
          message: this.$i18n.t('field_required')
        }, {
          validator: this.checkNewPassword
        }]
      },
      passwordVisible: false,
      loading: false,
      plans: null,
      intervals: [
        {
          name: 'one_week',
          value: secondsInWeek()
        },
        {
          name: 'one_month',
          value: secondsInMonth()
        },
        {
          name: 'three_months',
          value: secondsInThreeMonth()
        }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'domainsPath',
      'usersPath'
    ])
  },
  methods: {
    ...mapActions([
      'handleRequest'
    ]),
    toggleLoading () {
      this.loading = !this.loading
    },
    setPhoneNumberMask () {
      return {
        pattern: '(+98)9**-*******',
        formatCharacters: {
          '*': {
            validate: char => /[0-9]|[۰-۹]/.test(char),
            transform: char => converntDigitsToLatin(char)
          }
        }
      }
    },
    updateList (user) {
      const message = this.$i18n.t('is_successful', {
        operation: this.$i18n.t('add_user')
      })
      this.$emit('user-added', user)
      this.$emit('close-clicked')
      this.$message({
        message,
        type: 'success'
      })
    },
    updateTeamPlan (res) {
      const { team, id } = res
      const { domainsPath, plan, plans } = this
      const teamID = team.id.numberStr
      console.log(team, 'add')
      let toUpdate = plans.find(p => p.id.numberStr === plan.id)
      toUpdate.id = toUpdate.id.numberStr
      toUpdate.limitations = toUpdate.limitations.map(l => {
        return {
          name: l.name,
          cap: l.cap
        }
      })
      toUpdate.limitations = toUpdate.limitations.reduce(function (limit, item) {
        limit[item.name] = {
          cap: item.cap,
          label: item.name
        }
        return limit
      }, {})
      toUpdate.features = toUpdate.features.reduce(function (feature, item) {
        let value
        if (item.name === 'media') {
          value = item.value.map(v => v.id.numberStr)
        } else {
          value = item.value
        }
        feature[item.name] = {
          label: item.label,
          value
        }
        return feature
      }, {})
      toUpdate['remaining'] = plan.expiration
      this.handleRequest({
        name: `${domainsPath}/users/${id.numberStr}/teams/${teamID}/current_plan`,
        action: 'update',
        data: {
          id: null,
          toUpdate
        }
      }).then(() => {
        this.updateList(res)
      }).finally(this.toggleLoading)
    },
    createUserWithTeam () {
      const { user, domainsPath } = this
      if (user.team.name.length === 0) {
        this.user.team.name = user.name
      }
      this.user.mobile = user.mobile.replace(/[(\-)]+/g, '')
      this.toggleLoading()
      this.handleRequest({
        name: `${domainsPath}/user-with-team`,
        action: 'create',
        data: user
      }).then(this.updateTeamPlan)
        .catch(this.toggleLoading)
    },
    setPlans (res) {
      const { list } = res
      this.plans = list
      this.plan.id = list[0].id.numberStr
    },
    getData () {
      const { domainsPath } = this
      this.handleRequest({
        name: `${domainsPath}/plans`,
        action: 'getAll',
        data: {
          query: {
            limit: 200
          }
        }
      }).then(this.setPlans)
    }
  },
  created () {
    this.getData()
  },
  components: {
    MaskedInput
  }
}
</script>
